/***
*
*   APP LAYOUT
*   Main application layout containing the navigation
*   and header (title, secondary nav and signed in user)
*
*   PROPS
*   title: title of the view
*
**********/

import { Fragment, useContext } from 'react';

import { AuthContext, AppNav, Header, User, useTranslation } from 'components/lib';
import Style from './appMobile.module.scss';
import { navigateItems } from '../app/app';


export function AppMobileLayout(props) {
    const context = useContext(AuthContext);
    const { t } = useTranslation();

    return (
        <Fragment>

            <div>
                <AppNav
                    items={navigateItems(context, t)}
                />
                <main className={Style.app}>

                    <Header sideBarItems={navigateItems(context, t)} title={t(props.title) || props.title}>
                        <User />
                    </Header>

                    {<props.children t={t}/>}

                </main>
            </div >
        </Fragment>
    );
}